import IconDrakeOcean from './IconDrakeOcean';

export default IconDrakeOcean;